import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import * as changelogsAPI from '@debbie/cortex/dist/api/changelogs.js';
import { selectMe } from '@debbie/cortex/dist/me/selectors.js';
import THEME from '../theme.js';
import Button from './Button.js';
import { ArrowRight } from './Icons/index.js';
import Modal from './Modal.js';
const ChangelogComponent = () => {
    const lang = useSelector((s) => s.lang);
    const me = useSelector(selectMe);
    const [changelogOpen, setChangelogOpen] = useState(false);
    const [unseenChangelogs, setUnseenChangelogs] = useState(null);
    const getChangelogs = async () => {
        const changelogs = await changelogsAPI
            .getUnseen()
            .then((res) => res.changelogs);
        setUnseenChangelogs(changelogs);
        if (changelogs.length) {
            setChangelogOpen(true);
        }
    };
    useEffect(() => {
        if (me != null) {
            getChangelogs();
        }
    }, [me]);
    const closeModal = () => {
        setChangelogOpen(false);
        if (unseenChangelogs)
            changelogsAPI.dismiss({
                changelogIds: unseenChangelogs.map((changelog) => changelog.id),
            });
    };
    return changelogOpen ? (React.createElement(Modal, { header: lang.changelogs.changelog, onToggle: () => closeModal(), maxWidth: "765px", footer: React.createElement(React.Fragment, null,
            React.createElement(Button, { style: { marginBottom: '0' }, theme: "secondary", onClick: () => {
                    closeModal();
                } }, lang.changelogs.close)) },
        unseenChangelogs &&
            unseenChangelogs.map((changelog, index) => (React.createElement(React.Fragment, null,
                React.createElement(Changelog, { changelog: changelog }),
                index !== unseenChangelogs.length - 1 && (React.createElement("hr", { style: {
                        margin: '30px -20px',
                        border: '1px solid lightgray',
                    } }))))),
        React.createElement("br", null))) : null;
};
export default ChangelogComponent;
export const Changelog = (props) => {
    const lang = useSelector((s) => s.lang);
    const { changelog } = props;
    return (React.createElement("div", null,
        changelog.headerImgUrl && (React.createElement("img", { style: { borderRadius: '5px', width: '100%' }, src: changelog.headerImgUrl })),
        React.createElement("p", { style: { fontSize: '0.8em' } }, moment(changelog.createdAt).format(THEME.DATE_FORMAT)),
        React.createElement(RenderChangelogHTML, { html: changelog.body }),
        changelog.bookDemoLink && (React.createElement(React.Fragment, null,
            React.createElement("br", null),
            React.createElement("br", null),
            React.createElement("a", { target: "_blank", href: changelog.bookDemoLink, rel: "noreferrer" },
                React.createElement(BookDemoStyled, null,
                    React.createElement("img", { height: "35px", src: "https://api.debbiecollect.com/files/47f28439-b24d-4315-b034-4eecebf236a3/jo.png" }),
                    React.createElement("p", null, lang.changelogs.bookDemo),
                    React.createElement(ArrowRight, null)))))));
};
const BookDemoStyled = styled.div `
  border-radius: 40px;
  background-color: ${THEME.COLOR_PRIMARY};
  padding: 5px;
  color: white;
  display: inline-block;

  img {
    margin-right: 10px;
    display: inline-block;
    vertical-align: middle;
  }

  p {
    display: inline-block;
    margin: 0 10px 0 0;
  }

  svg {
    vertical-align: middle;
    margin-right: 7px;
  }
`;
const RenderChangelogHTML = (props) => {
    const frame = useRef(null);
    const setContentHeight = (doc) => {
        const height = doc?.body?.scrollHeight;
        if (height && frame && frame.current) {
            frame.current.style.height = `${height}px`;
        }
    };
    const updateFrame = (props) => {
        if (frame && frame.current) {
            const contentWindow = frame.current.contentWindow;
            if (contentWindow) {
                const doc = contentWindow.document;
                doc.open();
                doc.write(`<div><style>body { overflow: hidden; }</style>${props ? props.html : ''}</div>`);
                doc.close();
                frame.current.style.height = '0';
                contentWindow.onload = () => {
                    setContentHeight(doc);
                };
            }
        }
    };
    useEffect(() => {
        updateFrame();
    }, []);
    useEffect(() => {
        updateFrame(props);
    }, [props.html]);
    return (React.createElement("iframe", { style: {
            width: '100%',
            border: 'none',
            height: 'auto',
            margin: '0 -10px',
        }, src: "about:blank", ref: frame, sandbox: "allow-same-origin allow-scripts allow-popups", className: "ui-test-5c14306c" }));
};
//# sourceMappingURL=Changelog.js.map